import * as React from "react";
import { GetStarsBackgroundValue } from "source/app/services/UI/Stars/GetStarsBackgroundValue";
import { State } from "source/app/services/UI/State/State";
import Player from "../../../../domain/Player";
import Data from "../../../../services/Data";
import MotwLogicServer from "../../../../services/External/LogicServer/MotwLogicServer";
import Intervals from "../../../../services/Intervals";
import Nameof from "../../../../services/NameOf";
import { ESharedComponent } from "../../../../services/UI/State/ESharedComponent";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { CanSetState, SetState } from "../../../../services/UI/State/SetState";
import { IHeaderState } from "../../Header";
import {
    GetAheadByTime,
    GetTodaysActualProgress,
    GetTodaysExpectedProgress,
} from "../../ProgressBar/Helpers/CalculateTodaysProgress";
import { TodaysProgressBarState } from "../../ProgressBar/TodaysProgressBar/TodaysProgressBar";
import { TodaysTimeState } from "source/app/presentation/Header/Center/TodaysTime/TodaysTime";
import { IPlayerKipsTodayDTO } from "../../../../../../../motw_core/DTOs/IPlayerKipsTodayDTO";
import { BannerImages } from "../../../../services/Shared/RenderSwal/BannerImage/BannerImage";
import RenderSwal from "../../../../services/Shared/RenderSwal/RenderSwal";
import DeepWorkKipsChart from "./DeepWorkKipsChart/DeepWorkKipsChart";

export interface DeepWorkKipsTodayState {
    kipsDTO: IPlayerKipsTodayDTO;
    dailyTarget: number;
    MetDailyTarget: boolean;
}

class DeepWorkKipsToday extends React.PureComponent<
    {},
    DeepWorkKipsTodayState
> {
    constructor(props: any) {
        super(props);

        this.state = {
            kipsDTO: {
                kipsToday: 0,
                kipsByGoal: [],
            },
            dailyTarget: Player.deepWorkKipsTarget,
            MetDailyTarget: false,
        };
    }

    async componentDidMount() {
        Data.Load.Component({
            component: this,
            load: MotwLogicServer.GetKipsEarnedToday,
            stateTarget: Nameof<DeepWorkKipsTodayState>("kipsDTO"),
            inLoadAll: true,
        });

        Intervals.Start({
            name: "updateTodaysPerformance",
            execute: () =>
                this.UpdateTodaysPerformance(
                    this.state.kipsDTO.kipsToday,
                    this.state.dailyTarget
                ),
            period: 60000,
        });

        State.ShareClass(ESharedComponent.DeepWorkKipsToday, this);
    }

    async componentDidUpdate() {
        const { kipsDTO, dailyTarget } = this.state;
        const metDailyTarget = kipsDTO.kipsToday >= dailyTarget;

        if (metDailyTarget !== this.state.MetDailyTarget) {
            this.setState({ MetDailyTarget: metDailyTarget });
        }

        this.UpdateTodaysPerformance(
            kipsDTO.kipsToday,
            dailyTarget,
            metDailyTarget
        );
        this.UpdateHeaderStyling(metDailyTarget);

        if (CanSetState(ESharedFunction.GoalLimitWarnings_data)) {
            SetState(
                ESharedFunction.GoalLimitWarnings_data,
                this.state.kipsDTO
            );
        }

        State.ShareClass(ESharedComponent.DeepWorkKipsToday, this);
    }

    componentWillUnmount() {
        Data.Unload(this);
        Intervals.Stop("updateTodaysPerformance");
    }

    private UpdateHeaderStyling(metDailyTarget: boolean) {
        State.ReadClass<IHeaderState>(ESharedComponent.Header).setState({
            metDailyTarget,
        });
    }

    private UpdateTodaysPerformance(
        kipsToday: number,
        dailyTarget: number,
        metDailyTarget: boolean = this.state.MetDailyTarget
    ) {
        if (dailyTarget) {
            this.UpdateTodaysProgressBar(
                kipsToday,
                dailyTarget,
                metDailyTarget
            );

            const starsBackgroundValue = GetStarsBackgroundValue(
                kipsToday,
                dailyTarget
            );

            if (CanSetState(ESharedFunction.Stars)) {
                SetState(ESharedFunction.Stars, starsBackgroundValue);
            }

            if (CanSetState(ESharedFunction.Sunrise_progressPercent)) {
                SetState(
                    ESharedFunction.Sunrise_progressPercent,
                    starsBackgroundValue
                );
            }
        }
    }

    private UpdateTodaysProgressBar(
        kipsToday: number,
        dailyTarget: number,
        metDailyTarget: boolean
    ) {
        State.ReadClass<TodaysProgressBarState>(
            ESharedComponent.TodaysProgressBar
        ).setState({
            expectedProgress: GetTodaysExpectedProgress(),
            actualProgress: Math.min(
                GetTodaysActualProgress(kipsToday, dailyTarget),
                100
            ),
            show: !metDailyTarget,
        });
    }

    render() {
        return null;
    }
}

export default DeepWorkKipsToday;

export function ShowDeepWorkKipsToday() {
    RenderSwal(
        { bannerImage: BannerImages.starsStack },
        <DeepWorkKipsChart />,
        () => {}
    );
}
